module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cydCC"))).then(() => parcelRequire('eppYu'));